var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getSelectOrg.selectOrg.orgName)?_c('div',[_c('ul',_vm._l((_vm.menu),function(item,index){return _c('router-link',{key:index,attrs:{"tag":"li","to":item.link}},[_c('a-icon',{attrs:{"type":item.ico}}),_c('span',[_vm._v(_vm._s(item.name))])],1)}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }